<script lang="ts">
	import type { OperationModel } from '../../../models/api/OperationModel';
	import { AdaptiveImage } from '@wiseed/wikit';
	import ProjectTeamMember from './ProjectTeamMember.svelte';
	import { t } from 'svelte-i18n';
	import { capitalize, rnToBr } from '@wiseed/wikit';
	export let operation: OperationModel;
</script>

{#if operation.teamPhotos || operation.teamDescription || (operation.teamMembers && operation.teamMembers.length > 0) || (operation.gestionnaireProjet.teamMembers && operation.gestionnaireProjet.teamMembers.length > 0)}
	<section class="space-y-4">
		<h2>{capitalize($t('operation.team', { values: { operationName: operation.name } }))}</h2>
		{#if operation.teamPhotos}
			<AdaptiveImage src={operation.teamPhotos.url} alt={operation.teamPhotos.title} />
		{/if}
		{#if operation.teamDescription}
			<p>{@html rnToBr(operation.teamDescription)}</p>
		{/if}

		{#if operation.teamMembers}
			<div class="grid grid-cols-1 xl:grid-cols-3 gap-3">
				{#each operation.teamMembers as teammate}
					<ProjectTeamMember
						avatar={teammate.avatar}
						firstName={teammate.firstName}
						lastName={teammate.lastName}
						job={teammate.job}
						cv={teammate.cv}
						linkedIn={teammate.linkedIn}
					/>
				{/each}
			</div>
		{:else if operation.gestionnaireProjet.teamMembers && operation.gestionnaireProjet.teamMembers.length > 0}
			<div class="grid grid-cols-1 xl:grid-cols-3 gap-3">
				{#each operation.gestionnaireProjet.teamMembers as teammate}
					<ProjectTeamMember
						avatar={teammate.avatar}
						firstName={teammate.firstName}
						lastName={teammate.lastName}
						job={teammate.job}
						cv={teammate.cv}
						linkedIn={teammate.linkedIn}
					/>
				{/each}
			</div>
		{/if}
	</section>
{/if}
